import { createContext, useContext, useEffect, useState } from "react";
import config from "../twh/config";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const response = await fetch(
        config.reactApi_baseUrl + "/react-api/users/loginUser.php",
        { credentials: "include" }
      );

      const data = await response.json();

      if (data.status === true) {
        setUserData(data);
      } else {
        setUserData(null);
      }
    } catch (error) {
      console.error("Auth error:", error);
      setUserData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ userData, loading, fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);